var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
/**
* WinningsDataModel defines the input data and status of the winnings for particular event
*
* @typedef WinningsDataModel
* @type {type}
* @property {winnings} Winnings array of objects which contains the winning value and the current status
* @property {branchID} BranchId the id number of the current sport
*/
var WinningsDataModel = /** @class */ (function () {
    function WinningsDataModel(source) {
        this.winnings = source.winnings;
        this.branchID = source.branchID;
    }
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], WinningsDataModel.prototype, "winnings", void 0);
    return WinningsDataModel;
}());
export { WinningsDataModel };
//# sourceMappingURL=WinningsDataModel.js.map